import { render, staticRenderFns } from "./AreaPlantadaSojaSafra2024.vue?vue&type=template&id=2e15738c&lang=pug"
import script from "./AreaPlantadaSojaSafra2024.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaSojaSafra2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports